/**
 * data-toggle is the parent
 * data-toggle-trigger is the trigger
 * data-toggle-auto-height is the element that will get the max-height changed on toggle
 * data-toggle-suffix is the suffix for the trigger and class if multiple toggles are needed
 * data-toggle-event is the event name that will be dispatched on toggle and you can listen to it with window.addEventListener('toggle:global', e => {})
 * data-toggle-class is the class that will be toggled. default is is-active
 * data-toggle-add-to-id is the id of the element that will get the class added to it
 */

window.addEventListener('DOMContentLoaded', () => {
  if (document.location.hash) {
    const hash = document.location.hash.replace('#', '')
    const toggleParent = document.querySelector(`[aria-controls="${hash}-content"]`)
    console.log('toggleParent', toggleParent, `[aria-controls="${hash}-content"]`)
    if (toggleParent) {
      toggleParent.click()
    }
  }
})




document.querySelectorAll('[data-toggle]').forEach(toggleParent => {

  const suffix = toggleParent.hasAttribute('data-toggle-suffix') ? '-' + toggleParent.getAttribute('data-toggle-suffix') : ''

  const triggers = toggleParent.querySelectorAll(`[data-toggle-trigger${suffix}]`)
  const className = toggleParent.hasAttribute(`data-toggle-class${suffix}`) ? toggleParent.getAttribute(`data-toggle-class${suffix}`) : 'is-active'

  const autoHeightElement = toggleParent.querySelector('[data-toggle-auto-height]')
  const eventName = toggleParent.hasAttribute(`data-toggle-event${suffix}`) ? toggleParent.getAttribute(`data-toggle-event${suffix}`) : 'toggle:global'

  const addClassToElementSelector = toggleParent.hasAttribute(`data-toggle-add-to-id${suffix}`) ? toggleParent.getAttribute(`data-toggle-add-to-id${suffix}`) : false
  const addClassToElement = document.getElementById(addClassToElementSelector)

  const toggleHeight = () => {
    let isToggled = toggleParent.classList.contains(className)
    let event = new CustomEvent(eventName, {
      detail: {
        isToggled, toggleParent, triggers, className, autoHeightElement
      }
    })

    if (autoHeightElement && isToggled) {
      autoHeightElement.style.maxHeight = autoHeightElement.scrollHeight + 'px'
      autoHeightElement.setAttribute('aria-hidden', false)

    } else if (autoHeightElement) {
      autoHeightElement.style.maxHeight = 0
      autoHeightElement.setAttribute('aria-hidden', true)
    }

    triggers.forEach(trigger => {
      trigger.setAttribute('aria-expanded', isToggled)
    })

    window.dispatchEvent(event)
  }

  const toggle = e => {
    if(addClassToElementSelector != false) {
        addClassToElement.classList.toggle(className)
    } else {
        toggleParent.classList.toggle(className)
    }
    toggleHeight()
  }
  //console.log('triggers', triggers)
  triggers.forEach(trigger => trigger.addEventListener('click', e => toggle(e)))

  window.addEventListener('resize', () => toggleHeight())
  window.addEventListener('load', () => toggleHeight())
})
